// 楼栋结构配置 - 楼层从1楼开始
const makeFloors = (max) => Array.from({length: max}, (_, i) => String(i + 1));

export const BUILDINGS = {
  '1幢': {
    '1单元': { rooms: ['01', '02'], floors: makeFloors(33) },
    '2单元': { rooms: ['03', '04'], floors: makeFloors(33) }
  },
  '2幢': {
    '1单元': { rooms: ['01', '02'], floors: makeFloors(33) }
  },
  '3幢': {
    '1单元': { rooms: ['01', '02'], floors: makeFloors(33) }
  },
  '5幢': {
    '1单元': { rooms: ['01', '02'], floors: makeFloors(33) },
    '2单元': { rooms: ['03', '04'], floors: makeFloors(33) }
  },
  '6幢': {
    '1单元': { rooms: ['01', '02'], floors: makeFloors(33) },
    '2单元': { rooms: ['03', '04'], floors: makeFloors(33) }
  }
};

// 水表住宅楼层从2楼开始（无1楼）
export const WATER_BUILDINGS = {
  '1幢': {
    '1单元': { rooms: ['01', '02'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) },
    '2单元': { rooms: ['03', '04'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) }
  },
  '2幢': {
    '1单元': { rooms: ['01', '02'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) }
  },
  '3幢': {
    '1单元': { rooms: ['01', '02'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) }
  },
  '5幢': {
    '1单元': { rooms: ['01', '02'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) },
    '2单元': { rooms: ['03', '04'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) }
  },
  '6幢': {
    '1单元': { rooms: ['01', '02'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) },
    '2单元': { rooms: ['03', '04'], floors: Array.from({length: 32}, (_, i) => String(i + 2)) }
  }
};

export const PUBLIC_AREAS = ['地面', '地下室', '会所一楼', '会所二楼', '楼顶', '外围', '东门', '西门'];

export const PUBLIC_METER_TYPES = ['幼儿园', '绿化', '消防', '业主总表', '小区总表'];

export const ROLES = {
  admin: '管理员',
  general_manager: '总经理',
  manager: '项目经理',
  steward_chief: '内务主管',
  finance: '财务',
  steward: '管家',
  engineer: '工程',
  security: '保安',
  cleaner: '保洁',
  committee: '业主委',
  owner: '业主',
  fire_control: '消控',
  order_staff: '秩序员'
};

export const PRIORITY_COLORS = {
  '紧急': '#ff4d4f',
  '高': '#ff7a45',
  '中': '#1890ff',
  '低': '#52c41a'
};

export const STATUS_COLORS = {
  '待处理': '#ff4d4f',
  '处理中': '#1890ff',
  '已完成': '#52c41a'
};

export const COMPANY_NAME = '云彩环境 物业管理';
